export enum ParamType {
  ParamGroup = 'GROUP',
  Number = 'NUMERICAL',
  Percentage = 'NUMERICAL_PERCENTAGE',
  Bool = 'BOOLEAN',
  NumberRange = 'NUMERICAL_RANGE',
  PercentageRange = 'NUMERICAL_PERCENTAGE_RANGE',
  ExpiryLimit = 'EXPIRY_LIMIT_LIST',
  Expiry = 'EXPIRY_LIST',
  Phone = 'TEXT_LIST',
  Text = 'TEXT',
  ExpiryValue = 'EXPIRY_NUMBER_LIST',
  InstrumentValue = 'INSTRUMENT_NUMBER_LIST',
  TextNumberList = 'TEXT_NUMBER_LIST',
  TextPercentageList = 'TEXT_PERCENTAGE_LIST',
  HardLimitHandler = 'HARD_LIMIT_HANDLER',
  InstrumentArray = 'INSTRUMENT_LIST',
  OneWayHandler = 'ONE_WAY_HANDLER_LIST',
  TenorBucketHandlerList = 'TENOR_BUCKET_HANDLER_LIST',
  TenorBucketPercentageHandlerList = 'TENOR_BUCKET_PERCENTAGE_HANDLER_LIST',
  InstrumentPercentageList = 'INSTRUMENT_PERCENTAGE_LIST',
  ExpiryPercentageList = 'EXPIRY_PERCENTAGE_LIST',
  EventList = 'EVENT_LIST',
  ExpiryVegaAlphaByEdgeList = 'EXPIRY_VEGA_ALPHA_BY_EDGE_LIST',
  SweeperList = 'SWEEPER_LIST',
}

export interface BaseInputProps {
  value?: any;

  onChange?(val: any): void;
  onBlur?(): void;

  readonly?: boolean;
  className?: string;
  style?: any;

  [key: string]: any | undefined | null;
}

export interface ValidateInfo {
  [key: string]: undefined | string | ValidateInfo;
}
